import Services, { mainDomain } from "../../services";

export const switchURL = (URL) => {
    return mainDomain.split("api").length > 2
      ? URL.replace(/dev/, "apps")
      : URL.replace(/apps/, "dev");
  };